<template>
  <div class="google-translator" :class="{ 'google-translator--compact': compact }">
    <button
      v-for="country in countries"
      :key="country.code"
      class="google-translator__item"
      type="button"
      @click="translate(country.code)"
    >
      <img
        v-if="country.flagIconUrl"
        class="google-translator__flag"
        :src="country.flagIconUrl"
        :alt="country.altText || country.title"
      >
      <span v-if="!compact">{{ country.title }}</span>
    </button>
  </div>
</template>

<script>
export default {
  name: 'GoogleTranslator',
  props: {
    countries: {
      type: Array,
      required: true,
    },
    compact: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['on-country-click'],
  methods: {
    translate(code, attempt = 0) {
      const combo = document.querySelector('select.goog-te-combo');
      const canTranslate = typeof window.doGTranslate === 'function' && combo && combo.innerHTML.length > 0;

      if (canTranslate && typeof code === 'string' && code.includes('|')) {
        window.doGTranslate(code);
        this.$emit('on-country-click', code);
        return;
      }

      if (attempt < 12) {
        setTimeout(() => this.translate(code, attempt + 1), 500);
        return;
      }

      console.error('Google Translate ainda nao foi carregado ou nao criou o seletor interno.');
    },
  },
};
</script>

<style scoped>
.google-translator {
  display: grid;
  gap: 10px;
}

.google-translator__item {
  display: flex;
  align-items: center;
  gap: 10px;
  width: 100%;
  padding: 12px 16px;
  border: 1px solid #0479bf;
  border-radius: 10px;
  color: #0479bf;
  background: #ffffff;
  cursor: pointer;
  transition: transform 0.2s ease, background 0.2s ease, color 0.2s ease;
}

.google-translator__item:hover {
  color: #ffffff;
  background: #0479bf;
  transform: translateY(-1px);
}

.google-translator__flag {
  width: 28px;
  height: 20px;
  object-fit: cover;
  border-radius: 4px;
  border: 1px solid rgba(0, 0, 0, 0.08);
}

.google-translator--compact {
  display: inline-flex;
  align-items: center;
  gap: 6px;
}

.google-translator--compact .google-translator__item {
  width: auto;
  padding: 4px;
  min-width: 36px;
  border-radius: 50%;
  justify-content: center;
  border: 1px solid transparent;
  background: rgba(255, 255, 255, 0.95);
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
}

.google-translator--compact .google-translator__item:hover {
  background: rgba(4, 121, 191, 0.16);
  color: #0479bf;
  transform: translateY(0);
}

.google-translator--compact .google-translator__item span {
  display: none;
}

.google-translator--compact .google-translator__flag {
  width: 26px;
  height: 26px;
  border-radius: 50%;
}

</style>
